import { render, staticRenderFns } from "./RewardStudy.vue?vue&type=template&id=065de4c4&scoped=true"
import script from "./RewardStudy.vue?vue&type=script&lang=ts"
export * from "./RewardStudy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065de4c4",
  null
  
)

export default component.exports